<template>

    <div ref="app" class="ad_app">

        <Loader v-if="!ready"></Loader>

        <div class="ad_view" :class="{ 'menu-open': menuOpened }" v-else>

            <nav class="ad_view__menu" @click="closeMenu">
                <ul class="menu">
                    <li class="menu__item">
                        <router-link :to="{ name: routes.DASHBOARD }"
                            v-slot="{ href, navigate }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': $router.currentRoute.name === routes.DASHBOARD }" :href="href" @click="navigate">
                                <i class="fa fa-user-circle"></i>
                                <span class="menu-title">Mon profil</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item menu__item--divider"></li> 
                    <li class="menu__item menu-destockage" v-if="$setting('DESTOCKAGE_SECTION__ENABLED')" >
                        <router-link :to="{ name: routes.DESTOCKAGE_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-stack-overflow menu-destockage-icone"></i>
                                <span class="menu-title">Déstockage</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item">
                        <router-link :to="{ name: routes.ARTICLE_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-barcode"></i>
                                <span class="menu-title">Tarifs négociés</span>
                            </a>
                        </router-link>
                    </li>                
                    <li class="menu__item">
                        <router-link :to="{ name: routes.FAVORITE_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-heart"></i>
                                <span class="menu-title">Articles favoris</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item">
                        <router-link :to="{ name: routes.HABIT_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-history"></i>
                                <span class="menu-title">Habitudes</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item menu__item--divider">
                        <router-link :to="{ name: routes.DEVIS_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">                                
                                <i class="fa fa-edit"></i>
                                <span class="menu-title">Devis</span>
                            </a>
                        </router-link>
                    </li>                
                    <li class="menu__item">
                        <router-link :to="{ name: routes.COMMANDE_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-shopping-cart"></i>
                                <span class="menu-title">Commandes</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item">
                        <router-link :to="{ name: routes.BORDEREAU_LIVRAISON_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-truck"></i>
                                <span class="menu-title">Livraisons</span>
                            </a>
                        </router-link>
                    </li>     
                    <li class="menu__item" v-if="$can('VOIR_ECHEANCIERS')">
                        <router-link :to="{ name: routes.ECHEANCIER_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-hourglass-start"></i>
                                <span class="menu-title">Echéances</span>
                            </a>
                        </router-link>
                    </li>                           
                    <li class="menu__item" v-if="$can('VOIR_FACTURES')">
                        <router-link :to="{ name: routes.FACTURE_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-file-pdf-o"></i>
                                <span class="menu-title">Factures</span>
                            </a>
                        </router-link>
                    </li>                          
                    <li class="menu__item"  v-if="$setting('DOCUMENT_SECTION__ENABLED')" >
                        <router-link :to="{ name: routes.ARCHIVE_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-file-o"></i>
                                <span class="menu-title">Documents</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item menu__item--divider">
                        <router-link :to="{ name: routes.BUDGET_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-euro"></i>
                                <span class="menu-title">Budgets</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item" v-if="$can('CREER_MODIFIER_UTILISATEURS')">
                        <router-link :to="{ name: routes.UTILISATEUR_LIST }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-users"></i>
                                <span class="menu-title">Utilisateurs</span>
                            </a>
                        </router-link>
                    </li>
                    <li class="menu__item menu__item--divider"  v-if="$setting('SAV_SECTION__ENABLED')" >
                        <router-link :to="{ name: routes.SAV }"
                            v-slot="{ href, navigate, isActive }"
                            custom>
                            <a class="menu__item__link" :class="{ 'active': isActive }" :href="href" @click="navigate">
                                <i class="fa fa-wrench"></i>
                                <span class="menu-title">SAV</span>
                            </a>
                        </router-link>
                    </li>                    
                    <li class="menu__item menu__item--logout menu__item--divider">
                        <a class="menu__item__link" :href="$config.LOGOUT_URL">
                            <i class="fa fa-sign-out"></i>
                            <span class="menu-title">Se déconnecter</span>
                        </a>
                    </li>
                </ul>
            </nav>

            <div class="ad_view__container" id="top">

                <div class="ad_view__container__navigation">

                    <button class="menu-toggler"
                        type="button"
                        @click="toggleMenu">Menu</button>

                    <Breadcrumb />

                </div>

                <router-view
                    class="container woocommerce"
                    @click="closeMenu"
                    v-if="!onError"></router-view>

                <div class="container container--error" v-else>

                    <template v-if="errorCode == 404">

                        <img :src="errorImgPath" />
                        <strong>La page n'existe pas</strong>
                        <p>Nous ne sommes pas parvenu à trouver ce que vous cherchez</p>
                        <p>
                            <router-link
                                class="woocommerce-button button"
                                :to="{ name: routes.DASHBOARD }">Revenir à l'accueil</router-link>
                        </p>

                    </template>

                    <template v-else>

                        <img :src="errorImgPath" />
                        <strong>Une erreur empêche l'affichage de la page</strong>
                        <p>Si l'erreur persiste, veuillez contacter notre service client à <a :href="`mailto:` + $setting('CONTACT_SUPPORT')">{{ $setting('CONTACT_SUPPORT') }}</a>.</p>
                        <p>Nous nous excusons pour la gêne occasionnée.</p>

                    </template>

                </div>

            </div>

        </div>
    
    </div>

</template>

<script>
import { ErrorBus, FATAL_ERROR_EVENT, NOT_FOUND_ERROR_EVENT } from '@/plugins/myAdelya/MyAdelyaEvent'
import { actions as settingsActions } from '@/store/settings'
import { getRules } from '@/ability'
import { routes } from '@/router'
import { useImage } from '@/helpers/url';

import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue'
import Loader from '@/components/loader/Loader.vue'

export default {

    name: 'App',

     data: function() {
        return {
            errorCode: null,
            menuOpened: false,
            onError: false,
            ready: false
        }
    },

    computed: {

        errorImgPath: () => useImage('error-500.jpg'),

        routes: () => routes
    },

    methods: {

        closeMenu: function() {
            this.menuOpened = false;
        },

        handleError: function(error, code = 500) {
            console.warn(error ?? `Impossible de charger la page`)
            this.errorCode = code
            this.onError = true
        },

        handleResize: function() {
            this.resize();
        },

        resize: function() {
            let app = this.$refs.app
            let toTop = Math.round(app.parentNode.getBoundingClientRect().top)
            app.style.position = 'fixed'
            app.style.top = toTop + 'px'
        },

        toggleMenu: function() {
            this.menuOpened = !this.menuOpened
        },
    },

    created() {

        Promise.all([
            this.$store.dispatch(settingsActions.GET)
        ])
        .then( () => {
            const rules = getRules(this.$store.state.settings.current.ABILITIES)
            this.$ability.update(rules);
            this.ready = true
        })
    },

    mounted() {
        
        window.addEventListener('resize', this.handleResize)

        /// Redimmenssionement spécifique à Mesmerize
        let mesmerizeStyleElt = document.head.querySelector('#mesmerize-style-css')
        if ( mesmerizeStyleElt ) {
            let interval = setTimeout(() => {
                let loaded = Boolean(mesmerizeStyleElt.sheet)
                if ( loaded ) {
                    clearInterval(interval)
                    this.resize()
                }
            }, 50)
        }

        /// Workaround
        /// Au cas où il y a un raté pour certains navigateur
        /// On redimmensionne l'écran au bout de 4 sec
        setTimeout(() => this.resize, 4000)
         
        this.resize()

        // Page d'erreur
        ErrorBus.$on(NOT_FOUND_ERROR_EVENT, (error) => this.handleError(error, 404) )
        ErrorBus.$on(FATAL_ERROR_EVENT, this.handleError )
    },
    
    watch:{

        $route() {
            this.onError = false;
        }
    },

    components: {
        Breadcrumb,
        Loader
    }
}
</script>

<style>

/* Mesmerize override */

.myAdelya-app {
    overflow: hidden;
}

.myAdelya-app .inner-header-description {
    display: none;
}

.myAdelya-app .page-content {
    position: relative !important;
    padding: 0 !important;
}

.myAdelya-app .content {
    padding: 0 !important;
    margin: 0 !important;
    position: static !important;
}

.myAdelya-app .footer-content {
    display: none;
}


/* MyAdelya */

.ad_app {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(255, 255, 255);
    z-index: 1;
}

/* Le style ci-dessous pallie à des erreurs de marge Mesmerize */
.ad_app div::before,
.ad_app ul::before,
.ad_app article::before,
.ad_app aside::before,
.ad_app details::before,
.ad_app figcaption::before, 
.ad_app figure::before, 
.ad_app footer::before, 
.ad_app header::before, 
.ad_app hgroup::before, 
.ad_app menu::before, 
.ad_app nav::before, 
.ad_app section::before, 
.ad_app div::after, 
.ad_app ul::after, 
.ad_app article::after, 
.ad_app aside::after, 
.ad_app details::after, 
.ad_app figcaption::after, 
.ad_app figure::after, 
.ad_app footer::after, 
.ad_app header::after, 
.ad_app hgroup::after, 
.ad_app menu::after, 
.ad_app nav::after, 
.ad_app section::after {
  content: none;
  display: initial;
  width: auto;
}

.ad_view {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(255, 255, 255);
    /* border-top: 1px solid lightgray; */
    z-index: 1;
}

.ad_view__menu {
    position: absolute;
    top: 4rem;
    bottom: 0;
    left: 0;   
    z-index: 999;

    /* min-width: 5rem;
    max-width: 5rem;
    width: 5rem; */
    min-width: 17rem;
    max-width: 17rem;
    width: 17rem;
    overflow-y: auto;
    overflow-x: hidden;

    background-color: #f7f7f7;    
    border-right: 1px solid #eaeaea;
    transition: left 200ms;
}

.ad_view:not(.menu-open) .ad_view__menu {
    left: -17rem;
}

.ad_view.menu-open .ad_view__container {
    overflow-y: hidden;
}

.ad_view__container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
}

.ad_view__container__navigation {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 4rem;    
    min-height: 4rem;
    padding: 0 1.5rem;
    background-color: #fcfcfc;
}

.ad_view__container__navigation .menu-toggler {
    margin-right: 1.5rem;
    opacity: 0.5;
}

.ad_view__container__navigation .breadcrumb {
    flex: 1;
}

.ad_menu-item > i {
    margin-right: 0.3rem;
}

.container {
    position: relative;
    padding: 0.5rem 2rem;
    text-align: left;
    flex: 1;
    clip-path: inset(0 0 0 0); /* Permet d'avoir des elements fixed sans que la scrollbar ne soit cachée, magique ! */
}

.container.container--error {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    color: rgba(25, 25, 25, 0.5);
    text-align: center;
}

.container.container--error img {
    margin: 3rem;
}

.container.container--error strong {
    font-size: 150%;
    margin-bottom: 4rem;
}

.container.container--error p {
    font-size: 130%;
    margin: 0 0 1.5rem 0;
}

.container_list.container_list--no-result { 
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 5vh;
    margin-top: 40px;
}

.menu-toggler {
    display: inline-block;
    position: relative;
    background: transparent;
    border: none;
    outline: none;
    width: 38px;
    height: 38px;
    min-height: 38px;
    overflow: hidden;
    text-indent: -99999px;
    cursor: pointer;
}

.menu-toggler:before {
    content: "";
    position: absolute;
    top: 7px;
    left: 0;
    right: 0;
    display: block;
    height: 21px;
    border-color: rgba(25,25,25,.5);
    border-style: solid;
    border-width: 3px 0;
}
    
.menu-toggler:after {
    content: "";
    position: absolute;
    top: 19px;
    left: 0;
    right: 0;
    display: block;
    height: 3px;
    background-color: rgba(25,25,25,.5);
}

.menu {
    position: relative;
    margin: 0;
    padding: 0;
    padding-bottom: 4rem;
    min-height: 100%;
    list-style: none;
}

.menu .menu__item {
    margin-right: -1px;
}

.menu .menu__item.menu__item--logout {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 1px;
    background-color: #f7f7f7;
}

.menu .menu__item.menu__item--divider {
    border-top: 1px solid rgba(0,0,0,0.13);
}

.menu .menu__item .menu__item__link,
.menu .menu__item .menu__item__link:hover,
.menu .menu__item .menu__item__link:active {
    display: flex;
    align-items: center;
    height: 4rem;
    padding: 0 1rem 0 1.5rem;

    color: rgba(25, 25, 25, 0.5);
    cursor: pointer;
    font-size: 0.95em;
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
}

.menu .menu__item .menu__item__link:hover {
    background-color: rgba(13, 197, 193, 0.7);
}

.menu .menu__item .menu__item__link.active {
    background-color: rgb(13, 197, 193);
}

.menu .menu__item .menu__item__link i {
    height: 1.5rem;
    width: 1.5rem;
    display: inline-block;
    font-size: 1.5rem;
    margin-right: 1rem;
    opacity: 0.6;
}

.menu .menu-title {
    /* display: none; */
}

@media screen and (min-width: 800px) {

    .ad_view__menu {
        top: 0;
        min-width: 17rem;
        max-width: 17rem;
        width: 17rem;
    }

    .ad_view:not(.menu-open) .ad_view__menu {
        left: 0;
    }

    .ad_view__container {
        left: 17rem;
    }

    .ad_view__container__navigation {
        padding: 0 2rem;
        background: transparent;
    }

    .container.container--error img {
        margin-bottom: 5rem;
    }

    .container.container--error strong {
        font-size: 200%;
    }

    .container.container--error p {
        font-size: 150%;
    }

    .menu-toggler {
        display: none;
    }
    
    .menu .menu-title {
        display: inline;
    }
}

</style>
